/*
 * - SABBANG PAHAYA GAMANEEYAN -
 * Created on Mon Sep 12 2022 9:37:17 AM
 *
 * By Kapila Rathnayaka
 *
 * Copyright (c) 2022 Kayble Zone Private Limited - Colombo Sri Lanka
 * Contact : http://www.kayblezone.lk - kapilarathnayaka@outlook.com
 */

import React, { useEffect } from "react";
import HeroSectionContent from "../components/homepage/heroSectionContent";
import CompanySection from "../components/homepage/CompanySection";
import ServiceSection from "../components/homepage/ServicesSection";
import LatestSearch from "../components/homepage/LatestSearchSection";
import FooterSection from "../components/homepage/FooterSection";
import { useBreadCrumb } from "../context/BreadCrumbContext";
const Home = () => {
  const { breadCrumbLinks, setBreadCrumbLinks } = useBreadCrumb();
  useEffect(() => {
    setBreadCrumbLinks([{ name: "", link: "/" }]);
  }, []);
  return (
    <>
      <HeroSectionContent />
      <CompanySection />
      <ServiceSection />
      <LatestSearch />
    </>
  );
};

export default Home;
